module.exports = __webpack_public_path__ + "img/dsn.3d688a23.png";